import { updateUserKitRequest } from 'api/Shipment/api';

import { useState, useEffect } from 'react';

export const useUpdateUserKit = (onUpdated: (id: string, kitId: string) => void) => {
  const [ error, setError ] = useState('');
  const [ isLoading, setLoading ] = useState(false);

  useEffect(() => {
    return () => {
      setError('');
      setLoading(false);
    };
  }, []);

  const requestUpdateUserKit = (id: string, newKitId: string) => {
    setError('');
    setLoading(true);

    updateUserKitRequest(id, newKitId)
      .then(() => {
        onUpdated(id, newKitId);
      })
      .catch(error => setError(error?.response?.data?.message || 'Server error. Please try again.'))
      .finally(() => setLoading(false));
  };

  return {
    requestUpdateUserKit,
    isLoading,
    error,
    setError,
  };
};
